import { useState, useEffect } from "react";
import { orderCount, approveOrder, cancelOrder, reopenOrder, allOrders, getOrdersForSubsite, removeOrderItemAdmin } from '../../reducers/orders';
import { getUserCapabilities, getSubsite } from '../../reducers/auth';

import { useDispatch, useSelector } from "react-redux";
import Spinner from "react-bootstrap/Spinner";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import MSMPagination from '../MSMPagination';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Search, XCircle } from 'react-bootstrap-icons';
import { resolveImageUrl } from '../../utils/imageUrl';

const formatShipmentDate = (value) => {
  if (!value) return '—';
  const parts = String(value).slice(0, 10).split('-');
  if (parts.length === 3) {
    const d = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
    return d.toLocaleDateString('en-us', { year: "numeric", month: "short", day: "numeric" });
  }
  return new Date(value).toLocaleDateString('en-us', { year: "numeric", month: "short", day: "numeric" });
};

const AdminOrders = () => {
  const apiUrl = process.env.REACT_APP_LOCALHOST_URL;
  const { isSupervisor, isManager, isAdmin, isSuperAdmin, loading } = useSelector(state => state.auth);

  const orders = useSelector(allOrders);
  const orderCnt = useSelector(orderCount);
  const orderStatus = useSelector(state => state.orders.status);
  const approveStatus = useSelector(state => state.orders.approveStatus);
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [filter, setFilter] = useState("open");
  const [cancelOrderId, setCancelOrderId] = useState(0);
  const [resetPagination, setResetPagination] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [showNHK, setShowNHK] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [removeItem, setRemoveItem] = useState(null);
  const userCapabilities = useSelector(getUserCapabilities);
  const currentSubsite = useSelector(getSubsite);


  let perPage = 10;

  const handleClose = () => setShow(false);

  const handleShow = (orderId) => {
    console.log("ORDER ID", orderId);
    setShow(true);
    setCancelOrderId(orderId);
  };

  useEffect(() => {
    if (orderStatus === 'idle') {
      const range = [filter, 1, perPage, searchTerm, showNHK];
      dispatch(getOrdersForSubsite(range));
    }
  }, [orderStatus, dispatch]);

  useEffect(() => {
    const range = [filter, 1, perPage, searchTerm, showNHK];
    dispatch(getOrdersForSubsite(range));
  }, [showNHK]);

  useEffect(() => {
    const range = [filter, 1, perPage, searchTerm, showNHK];
    dispatch(getOrdersForSubsite(range));
  }, [filter, searchTerm, dispatch]);

  const cancelOrderClick = () => {
    dispatch(cancelOrder(cancelOrderId));
    setShow(false);
  }

  const approveOrderClick = (event, orderId) => {
    event.target.disabled = true;
    dispatch(approveOrder(orderId));
    setShow(false);
    event.target.disabled = false;
  }

  const reopenOrderClick = (event, orderId) => {
    event.target.disabled = true;
    dispatch(reopenOrder(orderId));
    event.target.disabled = false;
  }

  const handleRemoveItemShow = (orderId, item) => {
    setRemoveItem({ orderId, item });
  }

  const handleRemoveItemClose = () => setRemoveItem(null);

  const handleRemoveItemConfirm = () => {
    if (removeItem && removeItem.item) {
      dispatch(removeOrderItemAdmin(removeItem.item.id));
    }
    setRemoveItem(null);
  }

  let content = "";

  if (orderStatus === 'loading') {
    content = <Spinner text="Loading..." />
  } else if (orderStatus === 'succeeded') {
  } else if (orderStatus === 'failed') {
    content = <div>error</div>
  }

  if (orderStatus === 'loading') {
    content = <Spinner text="Loading..." />
  } else if (orderStatus === 'succeeded') {
    console.log("Orders", orders);
  } else if (orderStatus === 'failed') {
    content = <div>error</div>
  }


  const filterChanged = (event) => {
    console.log(event.target.value);
    setFilter(event.target.value);
    setResetPagination(!resetPagination);
  }

  const handleSearchChange = (event) => {
    setSearchInput(event.target.value);
  }

  const handleSearchSubmit = (event) => {
    event.preventDefault();
    setSearchTerm(searchInput);
    setResetPagination(!resetPagination);
  }

  const handleClearSearch = () => {
    setSearchInput("");
    setSearchTerm("");
    setResetPagination(!resetPagination);
  }

  const reloadData = (range) => {
    const params = [filter, range[0], range[1], searchTerm, showNHK];
    dispatch(getOrdersForSubsite(params));
  }

  return (
    <>
      <h2>Orders</h2>
      <MSMPagination reload={reloadData} perPage={perPage} total={orderCnt} reset={resetPagination} />

      <Container fluid>
        <Row className="mb-3">
          <Col md={6}>
            <Form.Select aria-label="Filter by status" onChange={filterChanged}>
              <option value="open">Open</option>
              <option value="approved">Approved</option>
              <option value="cancelled">Cancelled</option>
              <option value="finalized">Finalized</option>
            </Form.Select>
            <Form.Check
              type="checkbox"
              id="show-nhk"
              label="Show New Hire Kits"
              checked={showNHK}
              onChange={(e) => setShowNHK(e.target.checked)}
            />
          </Col>
          <Col md={6}>
            <Form onSubmit={handleSearchSubmit}>
              <div className="d-flex">
                <Form.Control
                  type="text"
                  placeholder="Search by order #, delivery name, delivery address, or ordered by name..."
                  value={searchInput}
                  onChange={handleSearchChange}
                />
                <Button
                  variant="primary"
                  type="submit"
                  className="ms-2"
                  style={{ whiteSpace: 'nowrap' }}
                >
                  <Search /> Search
                </Button>
                {searchTerm && (
                  <Button
                    variant="secondary"
                    onClick={handleClearSearch}
                    className="ms-2"
                    title="Clear search"
                  >
                    <XCircle />
                  </Button>
                )}
              </div>
              <div>
                Search by name, address, order number or date placed (mm/dd/yyyy)

              </div>
            </Form>
          </Col>
        </Row>
      </Container>

      {searchTerm && (
        <div className="alert-neutral alert-info">
          Searching for: <strong>{searchTerm}</strong>
        </div>
      )}
      {orders.length > 0 && orders.map(order => {
        let total = 0;
        let totalCount = 0;
        let items = [];
        console.log("ORDER", order);
        order.order_items.map(item => {
          const isPrintItem = item.printItemId && item.print_item;
          if (isPrintItem) {
            total += item.price;
          } else {
            total += (item.price * item.quantity);
          }
          totalCount += item.quantity;
          console.log("ITEM IN ORDER", item);

          if (isPrintItem) {
            const pi = item.print_item;
            const piImage = pi.imageUrl
              ? (pi.imageUrl.includes('uploads') ? apiUrl + pi.imageUrl : pi.imageUrl)
              : null;
            items.push(
              <div className="adminOrder">
                <Container fluid>
                  <Row>
                    <Col>
                      {piImage && <img src={piImage} height={'50'}></img>}
                    </Col>
                    <Col xs={6}>
                      {pi.title}
                    </Col>
                    <Col className="color"></Col>
                    <Col className="size-name"></Col>
                    <Col className="quantity">
                      {item.quantity}
                    </Col>
                    <Col className="price">
                      {(item.price).toLocaleString(undefined, { style: "currency", currency: "USD" })}
                    </Col>
                    {order.status === 'open' && (
                      <Col>
                        <Button variant="outline-danger" size="sm" onClick={() => handleRemoveItemShow(order.id, item)}>
                          Remove
                        </Button>
                      </Col>
                    )}
                  </Row>
                  {item.order_item_personalizations && item.order_item_personalizations.length > 0 && (
                    <Row>
                      <Col>
                        <div style={{ marginTop: 5, padding: 5, backgroundColor: '#f0f0f0', borderRadius: 4, fontSize: '0.9em' }}>
                          <strong>Personalization:</strong>
                          {item.order_item_personalizations.map((p, idx) => (
                            <span key={idx} style={{ marginLeft: 10 }}>
                              {p.fieldName || p.personalization_field?.name || 'Field'}: <strong>{p.fieldValue}</strong>
                            </span>
                          ))}
                        </div>
                      </Col>
                    </Row>
                  )}
                </Container>
              </div>);
            return;
          }

          items.push(
            <div className="adminOrder">
              <Container fluid>
                <Row>
                  <Col>
                    <img src={resolveImageUrl(item.product?.frontModelImage)} height={'50'}></img>
                  </Col>
                  <Col xs={6}>
                    {item.product?.style.title}
                  </Col>
                  <Col className="color">
                    {item.colorName}
                  </Col>
                  <Col className="size-name">
                    {item.sizeName}
                  </Col>
                  <Col className="quantity">
                    {item.quantity}
                  </Col>
                  <Col className="price">
                    {(item.price * item.quantity).toLocaleString(undefined, { style: "currency", currency: "USD" })}
                  </Col>
                  {order.status === 'open' && (
                    <Col>
                      <Button variant="outline-danger" size="sm" onClick={() => handleRemoveItemShow(order.id, item)}>
                        Remove
                      </Button>
                    </Col>
                  )}
                </Row>
                <Row>
                  <Col>
                    {item.subsite_decos?.map(logo => {
                      console.log("LOGO IN DECORATION", logo);
                      return logo.decoration_logo.decorationName + " - " + logo.deco_location.description;
                    })}
                  </Col>
                </Row>
                {/* Display personalization values */}
                {item.order_item_personalizations && item.order_item_personalizations.length > 0 && (
                  <Row>
                    <Col>
                      <div style={{ marginTop: 5, padding: 5, backgroundColor: '#f0f0f0', borderRadius: 4, fontSize: '0.9em' }}>
                        <strong>Personalization:</strong>
                        {item.order_item_personalizations.map((p, idx) => (
                          <span key={idx} style={{ marginLeft: 10 }}>
                            {p.fieldName || p.personalization_field?.name || 'Field'}: <strong>{p.fieldValue}</strong>
                          </span>
                        ))}
                      </div>
                    </Col>
                  </Row>
                )}
              </Container>
            </div>);
        });
        const shipments = order.order_shipments || [];
        return (
          <div className="admin-order-container">
            {order.newHireKit && currentSubsite.paymentOptions !== "kit" && (
              <div className="header" style={{ backgroundColor: "#66FF66", padding: 10 }}>
                <span style={{ fontWeight: "bold" }} >New Hire Kit</span>
                {order.kitFixedPrice && (
                  <span style={{ marginLeft: 20 }}>
                    Fixed Price: {parseFloat(order.kitFixedPrice).toLocaleString(undefined, { style: "currency", currency: "USD" })}
                  </span>
                )}
              </div>
            )}
            {order.newHireKit && currentSubsite.paymentOptions === "kit" && (
              <div className="header" style={{ backgroundColor: "#66FF66", padding: 10 }}>
                <span style={{ fontWeight: "bold" }} >Kit Order</span>
                {order.kitFixedPrice && (
                  <span style={{ marginLeft: 20 }}>
                    Fixed Price: {parseFloat(order.kitFixedPrice).toLocaleString(undefined, { style: "currency", currency: "USD" })}
                  </span>
                )}
              </div>
            )}
            {order.polybag && (
              <div className="header" style={{ borderRadius: 0, backgroundColor: "#66FF66", padding: 10 }}>
                <span style={{ fontWeight: "bold" }} >Polybag Label: {order.polybagLabel}</span>
              </div>
            )}
            <div className="header">
              <div><span className="caption">Date Placed</span><br />{new Date(order.placed).toLocaleDateString('en-us', { year: "numeric", month: "short", day: "numeric" })}</div>
              <div><span className="caption">Total</span><br />{(parseFloat(order.chargedToCC) + parseFloat(order.balanceUsed)).toLocaleString(undefined, {
                style: "currency",
                currency: "USD",
              })}</div>
              <div><span className="caption">Delivery Name</span><br />{order.deliveryName}</div>
              <div><span className="caption">Balance</span><br />{parseFloat(order.balanceUsed).toLocaleString(undefined, {
                style: "currency",
                currency: "USD",
              })}</div>
              <div><span className="caption">Ordered By</span><br />{order.orderedBy?.lastname}, {order.orderedBy?.firstname}</div>
              <div><span className="caption">Order #</span><br />{order.id}</div>
              <div><span className="caption">Status</span><br />{order.status.toUpperCase()}</div>
            </div>
            <div className="header">
              <div><span className="caption">Delivery Address</span><br />
                {order.deliveryAddress} {order.deliveryAddress2 != null && order.deliveryAddress2 != "" && <>{order.deliveryAddress2}</>} / {order.deliveryCity}, {order.deliveryState} {order.deliveryZip}<br />
              </div>
            </div>
            <div>
              {items}
            </div>
            <div className="total">Shipping: <strong>{order.shippingCost?.toLocaleString(undefined, {
              style: "currency",
              currency: "USD",
            })}</strong><br />
              Balance Used: <strong>{order.balanceUsed?.toLocaleString(undefined, {
                style: "currency",
                currency: "USD",
              })}</strong><br />
              Charged to CC: <strong>{parseFloat(order.chargedToCC).toLocaleString(undefined, {
                style: "currency",
                currency: "USD",
              })}</strong><br />
              Total ({totalCount} items): <strong>{(parseFloat(order.chargedToCC) + parseFloat(order.balanceUsed)).toLocaleString(undefined, {
                style: "currency",
                currency: "USD",
              })}</strong></div>

            <div style={{ padding: '12px 16px', borderTop: '1px solid #ddd', backgroundColor: '#f8f9fa' }}>
              <div className="mb-2">
                <span style={{ fontWeight: 600 }}>Shipments</span>
              </div>
              {shipments.length === 0 ? (
                <div style={{ color: '#666', fontSize: '0.9rem' }}>No shipment information yet.</div>
              ) : (
                shipments.map(shipment => (
                  <Container fluid key={shipment.id} className="mb-2" style={{ backgroundColor: '#fff', padding: 10, border: '1px solid #e0e0e0', borderRadius: 4 }}>
                    <Row className="align-items-center">
                      <Col md={4}>
                        <span className="caption">Shipping Date</span><br />
                        {formatShipmentDate(shipment.shippingDate)}
                      </Col>
                      <Col md={5}>
                        <span className="caption">Tracking Number</span><br />
                        {shipment.trackingNumber || '—'}
                      </Col>
                      <Col md={3}>
                        <span className="caption">Shipped</span><br />
                        {shipment.shipped ? 'Yes' : 'No'}
                      </Col>
                    </Row>
                  </Container>
                ))
              )}
            </div>

            <div className="total">
              {order.status === 'open' || order.status === 'approved' ? (

                <>
                  {order.status === 'open' ? (
                    <>
                      <Button variant="danger" onClick={() => handleShow(order.id)}>Cancel Order</Button>
                      {isSuperAdmin &&
                        <Button variant="success" onClick={(event) => approveOrderClick(event, order.id)}>Approve Order</Button>
                      }
                      {userCapabilities.map(capability => {
                        if (capability.capabilityName === "APPROVE_ORDERS")
                          return (<Button variant="success" onClick={(event) => approveOrderClick(event, order.id)}>Approve Order</Button>);
                      })}
                    </>

                  ) : null}
                  {order.status === 'approved' ? (
                    <>
                      {isSuperAdmin &&
                        <Button variant="danger" onClick={() => handleShow(order.id)}>Cancel Order</Button>
                      }
                    </>

                  ) : null}

                </>
              ) : null}
              {order.status === 'cancelled' && (
                <Button variant="success" onClick={(event) => reopenOrderClick(event, order.id)}>
                  Move to Open
                </Button>
              )}
            </div>
          </div>
        );
      })}

      {orders.length == 0 && (
        <div>No Orders</div>
      )
      }
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Cancel Order</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to cancel Order # {cancelOrderId} </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={cancelOrderClick}>
            Cancel the Order
          </Button>
          <Button variant="primary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={removeItem !== null} onHide={handleRemoveItemClose}>
        <Modal.Header closeButton>
          <Modal.Title>Remove Item</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Remove "{removeItem?.item?.product?.style?.title || removeItem?.item?.print_item?.title}"
          {removeItem?.item?.colorName ? ` (${removeItem.item.colorName} ${removeItem.item.sizeName})` : ''}
          &nbsp;from Order # {removeItem?.orderId}?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleRemoveItemConfirm}>
            Remove Item
          </Button>
          <Button variant="primary" onClick={handleRemoveItemClose}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default AdminOrders;

